import { $, $$ } from 'utils/dom';

export const initTeaserTooltip = teaserListItem => {
  const teaserListButton = $('.teaser-list__time-button', teaserListItem);
  const teaserListSubbox = $('.teaser-list__subdate-box', teaserListItem);

  if (teaserListButton && teaserListSubbox) {
    teaserListButton.addEventListener('click', () => {
      teaserListSubbox.classList.toggle('is-active');
    });
  }
};
const teaserListItems = $$('.teaser-list__item');
if (teaserListItems.length) {
  teaserListItems.forEach(teaserListItem => initTeaserTooltip(teaserListItem));
}
